import Operation from "core/models/Operation";
import OperationSet from "core/models/OperationSet";
import _ from "underscore";
import s from "underscore.string";
import BaseRouter from "core/base/Router";
var NavigationOperations = new OperationSet([
  new Operation({
    id: "back",
    icon: "circle-arrow-left",
    text: "Back to List",
    action: function (model) {
      BaseRouter.current.back();

      return Operation.resolve(model);
    },
  }),
]);

/**
 * Creates a simple navigation operation.
 * @param  {String} text        The identifier for the operation and the display text to associate with the operation.
 * @param  {String} icon        The icon identifier.
 * @param  {String} relativeUrl The url to be sent to `App.navigate` if the operation is invoked.
 * @param  {Boolean|Function} [available]   Either the value to return from the `available` function of the `Operation` or the function itself. Default is `true`.
 * @return {Operation}             The generated operation.
 */
NavigationOperations.createNavigationOperation = function (
  text,
  icon,
  relativeUrl,
  available
) {
  var _available = _.isFunction(available)
    ? available
    : function () {
        return _.isBoolean(available) ? available : true;
      };

  return new Operation({
    id: s.slugify(text),
    icon: icon,
    text: text,
    action: function (model) {
      BaseRouter.relativeNavigate(
        relativeUrl,
        model || {
          trigger: true,
        }
      );

      return Operation.resolve(model);
    },
    available: _available,
  });
};

export default NavigationOperations;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/operations/NavigationOperations.js
// module id = 85
// module chunks = 1